'use client';

import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { darkTheme } from '@/shared/modules/styled-system';
import * as Styled from './skeleton-content.styled';
interface SkeletonContentProps {
  sectionsCount?: number;
}
const SECTIONS_COUNT_BY_DEFAULT = 3;

/**
 * @useClient
 */
export const SkeletonContent = React.memo(function SkeletonContent({
  sectionsCount = SECTIONS_COUNT_BY_DEFAULT
}: SkeletonContentProps) {
  return <ThemeProvider theme={darkTheme}>
      <Styled.Content>
        <Styled.DefaultContent>
          {Array.from({
          length: sectionsCount
        }, (_, i) => <Styled.DefaultContentSection key={`skeleton-content-section-${i}`} />)}
        </Styled.DefaultContent>
      </Styled.Content>
    </ThemeProvider>;
});